import React from "react";
import Banner from "../components/Banner/Banner";
import Categories from "../components/Categories/Categories";
import NewArrival from "../components/New_Arrival/NewArrival";
import BigSale from "../components/BigSale/BigSale";
import PopularProducts from "../components/Popular Products/PopularProducts";
import ThreeFact from "../components/ThreeFact/ThreeFact";
import { Helmet } from "react-helmet-async";
import SpecialOffer from "../components/SpecialOffer/SpecialOffer";

function Home() {
  return (
    <div className="w-full relative space-y-20">
      <Helmet>
        <title>Ecoshoppe Ghana's No. 1 Online Gift Shop</title>
      </Helmet>
      <Banner />
      <Categories />
      <NewArrival />
      <BigSale />
      <PopularProducts />
      <SpecialOffer />
      <ThreeFact />
      <div></div>
    </div>
  );
}

export default Home;
